import Cookies from "js-cookie";

export const AUTH_COOKIE_NAME = "tacookie";

export const taco_cookie_ctx = Cookies.withAttributes({
  secure: true,
  expires: 365,
  sameSite: "strict",
});
